import React from 'react';
import PropTypes from 'prop-types';
import {SlideBlockContext} from '../SlideBlock';
import {Feedback} from '../SharedComponents/Feedback';
import {HexagonCard} from '@learningblocks/storybook-components';
import './style.scss';

const ENTER_KEY = 13;

/**
 * HexagonPathNode:
 *  - An option node for hexagon-joint-node
 */
export function HexagonPathNode(props) {
  const {getTabIndex} = React.useContext(SlideBlockContext);

  const getWrapper = () => {
    const {selected} = props.component;
    if (selected) {
      if (props.isCorrect) {
        return 'pathOption__correct';
      } else {
        return 'pathOption__incorrect';
      }
    } else {
      return 'pathOption';
    }
  };

  const selectNode = () => props.onNodeClick(props.component.id);

  const onNodeClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    selectNode();
  };

  const onKeyDown = (event) => event.keyCode === ENTER_KEY && selectNode();

  const renderFeedback = () => {
    if (props.component.selected) {
      return (
        <Feedback correct={props.isCorrect} message={props.feedbackMessage} />
      );
    } else {
      return null;
    }
  };

  const renderHexagonCard = () => (
    <HexagonCard tabIndex={getTabIndex()} {...props.component} />
  );

  const renderOverrideComponent = () =>
    React.cloneElement(props.overrides, {...props.component});
  return (
    <div
      tabIndex={getTabIndex()}
      className={getWrapper()}
      onClick={onNodeClick}
      onKeyDown={onKeyDown}>
      {props.overrides ? renderOverrideComponent() : renderHexagonCard()}
      {renderFeedback()}
    </div>
  );
}

HexagonPathNode.propTypes = {
  /**
   * Function to invoke when path node is clicked
   */
  onNodeClick: PropTypes.func,
  /**
   * Boolean to check if selected option is correct
   */
  isCorrect: PropTypes.bool,
  /**
   * Error message to display on hovering incorrect icon
   */
  feedbackMessage: PropTypes.string,
  /**
   * All properties for rendering the HexagonNode
   */
  component: PropTypes.shape({
    /**
     * Unique ID for the component
     */
    id: PropTypes.number,
    /**
     * Image for the icon
     */
    image: PropTypes.string,
    /**
     * Title of the Card
     */
    title: PropTypes.string,
    /**
     * Boolean to specify if component is selected
     */
    selected: PropTypes.bool,
    /**
     * Attributes for displaying the modal window with card details
     */
    modal: PropTypes.object,
  }),
};

HexagonPathNode.defaultProps = {
  isCorrect: null,
  feedbackMessage: '',
  onNodeClick: undefined,
};
